import React from 'react'
import { Routes as Router, Route, Navigate, Outlet } from 'react-router-dom'
import BaseLayout from '@/layout/baseLayout/BaseLayout'
import LoginLayout from '@/views/logins/loginLayout/LoginLayout'
import Login from '@/views/logins/login/Login'
import ChangePassword from '@/views/logins/changePassword/ChangePassword'
import RequestChangePassword from '@/views/logins/requestChangePassword/RequestChangePassword'
import VerifySignup from '@/views/logins/verifySignup/VerifySignup'

// Regular users
import UserSchemaSelector from '@/views/regularUsers/userSchemaSelector/UserSchemaSelector'
import UserCalendar from '@/views/regularUsers/userSchema/UserSchema'
import CreatedSchemas from '@/views/regularUsers/createdSchemas/CreatedSchemas'
import Files from '@/views/regularUsers/files/Files'

// Schema creators
import Users from '@/views/schemaCreators/users/Users'
import Attendance from '@/views/schemaCreators/attendance/Attendance'
import CreateSchema from '@/views/schemaCreators/createSchema/CreateSchema'
import Schemas from '@/views/schemaCreators/schemas/Schemas'
import SchemaUsers from '@/views/schemaCreators/schemaUsers/SchemaUsers'
import Scenes from '@/views/schemaCreators/scenes/Scenes'
import SceneGroups from '@/views/schemaCreators/sceneGroups/SceneGroups'
import Places from '@/views/schemaCreators/places/Places'

// const BaseLayout = React.lazy(() => import('@/layout/baseLayout/BaseLayout'))
// const LoginLayout = React.lazy(() => import('@/views/logins/loginLayout/LoginLayout'))
// const Login = React.lazy(() => import('@/views/logins/login/Login'))
// const ChangePassword = React.lazy(() => import('@/views/logins/changePassword/ChangePassword'))
// const RequestChangePassword = React.lazy(() => import('@/views/logins/requestChangePassword/RequestChangePassword'))
// const VerifySignup = React.lazy(() => import('@/views/logins/verifySignup/VerifySignup'))
// const UserCalendar = React.lazy(() => import('@/views/userSchema/UserSchema'))
// const Users = React.lazy(() => import('@/views/users/Users'))
// const Schemas = React.lazy(() => import('@/views/schemas/Schemas'))
// const SchemaUsers = React.lazy(() => import('@/views/schemaUsers/SchemaUsers'))
// const Scenes = React.lazy(() => import('@/views/scenes/Scenes'))
// const SceneGroups = React.lazy(() => import('@/views/sceneGroups/SceneGroups'))
// const UserSchemaSelector = React.lazy(() => import('@/views/userSchemaSelector/UserSchemaSelector'))
// const CreateSchema = React.lazy(() => import('@/views/createSchema/CreateSchema'))
// const CreateFinalSchema = React.lazy(() => import('@/views/createFinalSchema/CreateFinalSchema'))
const ApiDocs = React.lazy(() => import('@/views/admin/apiDocs/ApiDocs'))

// TODO: Build new endpoint to get profile info
// const ProtectedRoute: React.FC = () => {
//     const location = useLocation()
//     const [getUserQuery] = useLazyGetUserQuery()
//     const accessToken = localStorage.getItem("accessToken")
//     let element = <Navigate to="/login" replace />
//     React.useEffect(() => {
//         if (accessToken) {
//             getUserQuery({ id: Number(localStorage.getItem('userId')) })
//         }
//     }, [getUserQuery, location.pathname])

//     if (accessToken) {
//         element = <Outlet />
//     }
//     return element
// }

const ProtectedRoute: React.FC = () => {
  const accessToken = localStorage.getItem('accessToken')
  if (!accessToken) {
    return <Navigate to="/login" replace />
  }
  return <Outlet />
}

const Routes: React.FC = () => {
  return (
    <Router>
      <Route path="/" element={<LoginLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route
          path="/request-change-password"
          element={<RequestChangePassword />}
        />
        <Route path="/verify-signup" element={<VerifySignup />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<BaseLayout />}>
          <Route path="schema" element={<UserSchemaSelector />} />
          <Route path="schema/:schemaId/schema" element={<UserCalendar />} />
          <Route path="schema/:schemaId/created" element={<CreatedSchemas />} />
          <Route path="schema/:schemaId/files" element={<Files />} />
          <Route path="users" element={<Users />} />
          <Route
            path="users/:userId/schemas/:schemaId"
            element={<UserCalendar isSchemaCreator={true} />}
          />
          <Route path="schemas/:schemaId/attendance" element={<Attendance />} />
          <Route path="schemas/:schemaId/create" element={<CreateSchema />} />
          <Route path="schemas/:schemaId/users" element={<SchemaUsers />} />
          <Route path="schemas/:schemaId/scenes" element={<Scenes />} />
          <Route
            path="schemas/:schemaId/scene-groups"
            element={<SceneGroups />}
          />
          <Route path="schemas/:schemaId/places" element={<Places />} />
          <Route path="schemas" element={<Schemas />} />
          <Route path="api-docs" element={<ApiDocs />} />
          <Route path="*" element={<Navigate to="/schema" replace />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Router>
  )
}

export default Routes
